<div class="popup-content-wrapper">
  <ng-container *ngIf="!loading">
    <p class="popup-title">¿Quieres limpiar el carrito?</p>
    <p class="popup-body">Se eliminarán todas las entradas del carrito y serás redirigido a la página de selección de eventos</p>
  </ng-container>
  <div *ngIf="loading" class="popup-loading">
    <mat-progress-spinner diameter="36" mode="indeterminate" color="accent"></mat-progress-spinner>
    <p class="popup-loading-text">Limpiando carrito...</p>
  </div>
</div>